module.exports = __webpack_public_path__ + "0b63be79afc682954ba1a677f24545fc.png";